import React, { useMemo } from 'react';
import ReactModal from 'react-modal';
import styles from './modal.module.scss';
import { Button } from '../../button';
import { Icon } from '../../icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Modal = function Modal(_ref) {
  var label = _ref.label,
      targetId = _ref.targetId,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      children = _ref.children,
      modalClassName = _ref.modalClassName,
      showCloseButton = _ref.showCloseButton,
      _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick,
      shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? false : _ref$shouldCloseOnOve;
  var appElement = useMemo(function () {
    if (true) {
      var _document;

      return (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById(targetId);
    }

    return null;
  }, [targetId]);
  if (!appElement) return null;
  return /*#__PURE__*/_jsx(ReactModal, {
    isOpen: isOpen,
    preventScroll: true,
    appElement: appElement,
    closeTimeoutMS: 200,
    onRequestClose: onClose,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    overlayClassName: styles.overlay,
    className: styles.modal,
    contentLabel: label,
    children: /*#__PURE__*/_jsx("div", {
      className: modalClassName,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.container,
        children: [showCloseButton && /*#__PURE__*/_jsx(Button, {
          transparent: true,
          id: "modal_button_close",
          className: styles.closeButton,
          icon: /*#__PURE__*/_jsx(Icon, {
            name: "close",
            className: styles.closeIcon
          }),
          onClick: onClose
        }), /*#__PURE__*/_jsx("div", {
          children: children
        })]
      })
    })
  });
};